import { ref } from 'vue';

export enum PopupType {
  // 视窗背景颜色
  'bgColorPicker',
  'sendTutorial'
}

const popups = ref(new Set<PopupType>());

export const useEditorPopups = () => {
  const togglePopup = (popupType: PopupType) => {
    popupVisible(popupType)
      ? popups.value.delete(popupType)
      : popups.value.add(popupType);
  };
  const popupVisible = (popupType: PopupType) => popups.value.has(popupType);
  return {
    togglePopup,
    popupVisible,
    clear: () => {
      popups.value.clear();
    }
  };
};
